/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { COLOR } from "../utils/theme";

export default function Toast({ message, type = "success", visible }) {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    if (visible) {
      setOpacity(1);
    } else {
      setOpacity(0);
    }
  }, [visible]);

  if (!visible && opacity === 0) return null;

  const isError = type === "error";

  return (
    <div
      style={{
        position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)",
        zIndex: 1000,
        background: isError ? "rgba(122,61,80,0.12)" : "rgba(22,101,52,0.12)",
        borderRadius: 24,
        padding: "10px 20px",
        fontFamily: "monospace",
        fontSize: 13,
        color: isError ? COLOR.mauveDark : COLOR.savedGreen,
        maxWidth: "calc(100vw - 32px)",
        textAlign: "center",
        wordBreak: "break-word",
        opacity,
        transition: "opacity 0.3s ease",
        pointerEvents: "none",
      }}
    >
      {message}
    </div>
  );
}

// Hook for easy toast usage
export function useToast() {
  const [toast, setToast] = useState({ visible: false, message: "", type: "success" });
  const timerRef = useRef(null);

  const showToast = (message, type = "success", duration = 3000) => {
    clearTimeout(timerRef.current);
    setToast({ visible: true, message, type });
    timerRef.current = setTimeout(() => {
      setToast(t => ({ ...t, visible: false }));
    }, duration);
  };

  return [toast, showToast];
}
